// Versión de la aplicación
const appVersion = 'V.1.0.0';

// Mapa de códigos de entorno a URLs de API
const API_URLS = {
  '0A4C': 'https://apidemo.xtocks.app/api/1.0',
  'CYS25': 'https://apicys.xtocks.app/api/1.0',
  'ORGM3': 'https://apioriginalesgm.xtocks.app/api/1.0',
    'TBLC3': 'https://apitubhelca.xtocks.app/api/1.0',
  
};

// Nombre de la clave en localStorage para el código de entorno
const ENV_CODE_KEY = 'xtocks_environment_code';

// Obtener la URL de la API basada en el código almacenado o usar la URL por defecto
function getApiUrl() {
  // Intentar obtener el código de entorno del localStorage
  const savedEnvCode = localStorage.getItem(ENV_CODE_KEY);
  
  // Si hay un código guardado y está en nuestro mapa de URLs, usarlo
  if (savedEnvCode && API_URLS[savedEnvCode]) {
    return API_URLS[savedEnvCode];
  }
  
  // URL por defecto si no hay código guardado o no es válido
  return 'https://apidemo.xtocks.app/api/1.0';
}

// Configurar la URL de la API
var config_url = getApiUrl();

console.log('Backend Conected: ' + config_url);

// Exportar variables para uso en la aplicación
export const apiPath = config_url;
export { appVersion };

// Exportar funciones y constantes para la configuración del entorno
export const ENV_CODES = API_URLS;
export function saveEnvironmentCode(code) {
  if (API_URLS[code]) {
    localStorage.setItem(ENV_CODE_KEY, code);
    return true;
  }
  return false;
}

export function getEnvironmentCode() {
  return localStorage.getItem(ENV_CODE_KEY);
}

export function getEnvironmentName(code) {
  if (code === '0A4C') return 'DEMO';
  if (code === 'CYS25') return 'CYS';
  if (code === 'ORGM3') return 'ORIGINALES GM';
  if (code === 'TBLC3') return 'TUBHELCA';
  return 'DESCONOCIDO';
}
